import gql from 'graphql-tag';

export default gql`
  query findByAliasCourseQuery($alias: String!) {
    findByAliasCourseQuery(alias: $alias) {
      _id
      title
      image {
        path
      }
    }
  }
`;
